/**
 * Chart Terminal route — /chart/$ticker. Stock drill-down, not a fifth product
 * screen: same ticker parse as /stock/$ticker, plus optional `ma=0`.
 */
import {
  ChartSearchParamsSchema,
  MA_OVERLAY_OFF,
  type ChartSearchParams,
} from '@meridian/contracts';

import { chartSearchWrite } from '@/lib/nav/chart-studies';
import { createTickerDrilldownRoute } from '@/lib/router/ticker-drilldown-route';

import type { ChartTerminalRouteProps } from './chart-terminal-route';
import type { ComponentType } from 'react';

export const chartTerminalRoute = createTickerDrilldownRoute<
  ChartSearchParams,
  ChartTerminalRouteProps
>({
  path: '/chart/$ticker',
  crumbLabel: 'Chart Terminal',
  skeletonLabel: 'Loading chart terminal',
  load: () => import('./chart-terminal-route'),
  pick: (loaded) => loaded['ChartTerminalRoute'] as ComponentType<ChartTerminalRouteProps>,
  parseSearch: (search) => ChartSearchParamsSchema.parse(search),
  extraProps: ({ search, replaceSearch }) => ({
    maOn: search.ma !== MA_OVERLAY_OFF,
    onMaChange: (on: boolean) => {
      replaceSearch(
        chartSearchWrite(
          ChartSearchParamsSchema.parse(
            on ? { ...search, ma: undefined } : { ...search, ma: MA_OVERLAY_OFF },
          ),
        ),
      );
    },
  }),
});
